import Assignment from '../api/assignment';
import { applicationSave, applicationFetch, applicationFetchAll } from './applicationActions';

export const saveAssignment = applicationSave(Assignment);
export const fetchAssignment = applicationFetch(Assignment);
export const fetchAssignments = applicationFetchAll(Assignment);
